<div *ngIf="translateService.currentLang==='en'">
    <div id="main-content" class="highlighted-container container">
        <div class="row">
            <div class="highlighted">  
                <div class="region region-highlighted">
                    <div data-drupal-messages-fallback="" class="hidden"></div>
                    <h1 class="page-header">
                        <span>Contact Us</span>
                    </h1>
                </div>
            </div>
        </div>
    </div>

     <div role="main" class="main-container container js-quickedit-main-content">
        <div class="row">
            <section class="col-sm-9">
                <div class="region region-content">
                    <article data-history-node-id="5" class="page full clearfix">
                        <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                <h2 class="big green"><strong>How can we help you?</strong></h2>
                                <p><b>Here's how you can reach us:</b></p>
      
                                <div class="flex-wrap contact-icons">
                                    <div class="i"><img alt="Phone Icon" border="0" src="./assets/images/icons/phone_icon.png">
                                    <p><b>Call 1.888.703.5765</b><br>
                                    Representatives are available<br>
                                    8:00 AM to 8:00 PM EST,<br>
                                    Monday through Friday.</p>
                                    </div>
        
                                    <div class="i">
                                        <a href="mailto:clientrelations@cdlsi.com?subject=Client%20Feedback" target="_blank">
                                        <img alt="Send email" border="0" src="./assets/images/icons/email_icon.png"></a>       
                                        <p><b>Send us an Email</b><br>
                                        We&nbsp;will get back to you as soon as possible during regular business&nbsp;hours.</p>
                                    </div>
        
                                    <!-- <div class="i">
                                        <a href="javascript:void(0);" id="contactChatIcon" (click)="startChat()">
                                            <img alt="Open live chat" border="0" src="./assets/images/icons/chat_icon.png">
                                        </a>
                                        <p><b>Live Chat</b><br>
                                        Representatives are available 9:00 AM to 5:00 PM EST, Monday through&nbsp;Friday.</p>
                                    </div> -->
                                </div>
      
                                <p><a routerLink="/privacy-policy" title="Privacy Policy">Read our privacy policy.</a></p>
      
                                <h3 class="red">Hours of Operation</h3>
                                
                                <p>Monday through Friday: 8:00 AM to 8:00 PM EST<br>
                                Closed weekends and statutory holidays.</p>
                            </div>
                        </div>
                    </article>
                 </div>
            </section>
      
            <aside class="col-sm-3">
                <div class="region region-sidebar-second">
                    <section id="block-cdlsihoursofoperation" class="block block-block-content clearfix">
                        <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <h3 class="red">Address (mailing purposes)</h3>
                            <p>Canadian Dealer Lease Services Inc.<br>2 Bloor Street West, Suite 700<br>Toronto, ON&nbsp;M4W 3E2</p><p>&nbsp;</p>
                            <h3 class="red">Client Relations &amp; General Inquiries</h3><p>1.888.703.5765 or 
                            <a href="mailto:clientrelations@cdlsi.com" title="clientrelations@cdlsi.com">clientrelations&#64;cdlsi.com</a></p>
                            <p>Career Opportunities and HR Related Inquiries&nbsp;</p>
                            <p><a href="mailto:careers@CDLSI.com" title="careers@CDLSI.com">careers&#64;cdlsi.com</a></p>
                        </div>
                    </section>
                </div>
            </aside>
        </div>
    </div>
</div>


<div *ngIf="translateService.currentLang==='fr'">
    <div id="main-content" class="highlighted-container container">
        <div class="row">
            <div class="highlighted">  
                <div class="region region-highlighted">
                    <div data-drupal-messages-fallback="" class="hidden"></div>
                    <h1 class="page-header">
                        <span>Contact</span>
                    </h1>
                </div>
            </div>
        </div>
    </div>

    <div role="main" class="main-container container js-quickedit-main-content">
        <div class="row">
            <section class="col-sm-9">
                <div class="region region-content">
                    <article data-history-node-id="5" class="page full clearfix">
                        <div class="content">
                            <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                                <h2 class="big green"><strong>Comment pouvons-nous vous aider?</strong></h2>
                                <p><b>Voici comment vous pouvez nous joindre :</b></p>
                                
                                <div class="flex-wrap contact-icons">
                                    <div class="i"><img alt="Icône de téléphone" border="0" src="./assets/images/icons/phone_icon.png">
                                    <p><b>Appeler 1.888.703.5765</b><br>
                                    Nos représentants sont disponibles<br>
                                    de 8h00 à 20h00&nbsp;HNE,<br>
                                    du lundi au&nbsp;vendredi.</p>
                                    </div>
                                
                                    <div class="i"><a href="mailto:relationclientele@cdlsi.com?subject=Commentaires%20des%20clients" target="_blank">
                                        <img alt="Envoyer un courriel" border="0" src="./assets/images/icons/email_icon.png"></a>
                                        <p><b>Envoyez-nous un courriel </b><br>
                                        Nous vous répondrons dans les plus brefs délais pendant les heures normales&nbsp;d'ouverture.</p>
                                    </div>
                                
                                    <!-- <div class="i">
                                        <a href="javascript:void(0);" id="contactChatIcon" (click)="startChat()">
                                            <img alt="Cliquez pour ouvrir le chat" border="0" src="./assets/images/icons/chat_icon.png">
                                        </a>
                                        <p><b>Clavardage en ligne </b><br>
                                        Clavarder avec un représentant en direct de 9h00 à 17h00 HNE, du lundi au vendredi.</p>
                                    </div> -->
                                </div>
                                
                                <p><a routerLink="/privacy-policy" title="Politique de confidentialité">Lisez notre politique de confidentialité.</a></p>
                                
                                <h3 class="red">Heures d’ouverture</h3>
                                
                                <p>Du lundi au vendredi: 8h00 à 20h00&nbsp;HNE<br>
                                Fermé les fins de semaine et les jours&nbsp;fériés.</p>
                            </div>
                        </div> 
                    </article>
                </div>
            </section>

            <aside class="col-sm-3">
                <div class="region region-sidebar-second">
                    <section id="block-cdlsihoursofoperation" class="block block-block-content clearfix">   
                        <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                            <h3 class="red">Adresse (fins d'envoi de courrier)</h3>
                            <p>Services&nbsp;de&nbsp;location des concessionnaires automobiles&nbsp;canadiens.<br>2 rue Bloor Ouest, bureau 700<br>Toronto, ON&nbsp; M4W 3E2</p>
                            <p>&nbsp;</p>
                            <h3 class="red">Relations avec la clientèle et Demandes de renseignements</h3>
                            <p>1.888.703.5765 or <a href="mailto:relationclientele@cdlsi.com" title="clientrelations@cdlsi.com">relationclientele&#64;cdlsi.com</a></p>
                            <p>Possibilités de carrière et demandes liées aux ressources humaines&nbsp;</p>
                            <p><a href="mailto:careers@CDLSI.com" title="careers@CDLSI.com">careers&#64;cdlsi.com</a></p>
                        </div>
                    </section>
                    </div>
            </aside>
        </div>
    </div>
</div>